import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dac-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/terms-and-conditions/terms-and-conditions.component.ts